import React from 'react';
import PropTypes from 'prop-types';
import styled from 'react-emotion';
import Modal from 'react-modal';

import closeIcon from '../assets/icon/close.png';
import addBg from '../assets/img/jia_zc_icon@3x.png';
import subBg from '../assets/img/jian_zc_icon@3x.png';

import { LargePrimaryButton } from './button';

const overlayStyle = {
  backgroundColor: 'rgba(0, 0, 0, 0.5)',
  top: '0px',
};

const contentStyle = {
  top: 'auto',
  left: '0',
  right: '0',
  bottom: '0',
  padding: '0',
  backgroundColor: 'white',
  border: 'none',
  borderRadius: '0',
};

const ModalContent = styled.div`
  position: relative;
  width: 100%;
  height: 100%;

  display: flex;
  flex-flow: column nowrap;
  justify-content: start;
  align-items: center;  
`;

ModalContent.Icon = styled.div`
  margin: 20px 20px 0 0;
  width: 46px;
  height: 46px;
  background-image: url(${closeIcon});
  background-size: cover;
  align-self: flex-end;
`;

ModalContent.SubmitButton = styled(LargePrimaryButton)`
  width: 100%;
  margin: 0;
`;

const InputContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  padding: 40px 60px 76px 60px;
`;

const InputWidget = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`;

InputWidget.Label = styled.label`
  margin: 0;
  color: rgb(102, 102, 102);
  font-size: 43px;
  line-height: 1;
`;

InputWidget.InputBox = styled.div`
  margin: 0;
  margin-top: 42px;
  width: 160px;
  height: 254px;
  border: 1px solid #999;
  border-radius: 10px;
  display: flex;
  flex-direction: column;
`;

InputWidget.Button = styled.div`
  width: 100%;
  height: 88px;
  flex-grow: 0;
  font-size: 86px;
  text-align: center;
  line-height: 88px;
  color: black;
  overflow: hidden;
`;

InputWidget.Add = styled(InputWidget.Button)`
  background-image: url(${addBg});
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;
`;

InputWidget.Sub = styled(InputWidget.Button)`
  background-image: url(${subBg});
  border-bottom-left-radius: 10px;
  border-bottom-right-radius: 10px;
`;

InputWidget.Text = styled.input`
  width: 100%;
  height: 78px;
  flex-grow: 0;
  flex-shrink: 1;
  font-size: 40px;
  text-align: center;
  line-height: 75px;
  border: none;
`;

const DAYS_IN_MONTH = [
  null, 31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31,
];

class DateInputModal extends React.Component {
  constructor(props) {
    super(props);
    this.parseValue(props);
    this.state = {
      tempYear: this.y,
      tempMonth: this.m,
      tempDay: this.d,
    };
  }

  componentWillUpdate(props, newProps) {
    this.parseValue(newProps);
  }

  parseValue(props) {
    if (!props || !props.value || props.value.split('-').length !== 3) return;
    [this.y, this.m, this.d] = this.sanitize(...props.value.split('-').map(v => parseInt(v, 10)));
  }

  sanitize(y, m, d) {
    m = m > 12 ? 1 : m;
    m = m < 1 ? 12 : m;
    d = d > this.daysInMonth(y, m) ? 1 : d;
    d = d < 1 ? this.daysInMonth(y, m) : d;
    return [y, m, d];
  }

  isLeapYear(y) {
    return (y % 100 !== 0 && y % 4 === 0) || (y % 400 === 0);
  }

  daysInMonth(y, m) {
    return this.isLeapYear(y) && m === 2 ? 29 : DAYS_IN_MONTH[m];
  }

  change(y, m, d) {
    [y, m, d] = this.sanitize(y, m, d);
    this.props.onChange(`${y}-${m}-${d}`);
  }

  inputByType(t, v) {
    if (v && Number.isNaN(Number.parseInt(v, 10))) return;
    this.setState({ [`temp${t}`]: v ? Number.parseInt(v, 10) : '' });
  }

  changeByInput() {
    this.change(
      this.state.tempYear || this.y,
      this.state.tempMonth || this.m,
      this.state.tempDay || this.d
    );
  }

  increaseYear() {
    this.change(this.y + 1, this.m, this.d);
  }

  decreaseYear() {
    this.change(this.y - 1, this.m, this.d);
  }

  increaseMonth() {
    this.change(this.y, this.m + 1, this.d);
  }

  decreaseMonth() {
    this.change(this.y, this.m - 1, this.d);
  }

  increaseDay() {
    this.change(this.y, this.m, this.d + 1);
  }

  decreaseDay() {
    this.change(this.y, this.m, this.d - 1);
  }

  renderWidget(label, value, type) {
    return (
      <InputWidget>
        <InputWidget.Label>{label}</InputWidget.Label>
        <InputWidget.InputBox>
          <InputWidget.Add onClick={() => this[`increase${type}`]()}>+</InputWidget.Add>
          <InputWidget.Text
            value={this.state[`temp${type}`]}
            type='number'
            pattern='\d*'
            onClick={e => e.stopPropagation()}
            onBlur={() => this.changeByInput()}
            onChange={e => this.inputByType(type, e.target.value)}
          />
          <InputWidget.Sub onClick={() => this[`decrease${type}`]()}>&#8210;</InputWidget.Sub>
        </InputWidget.InputBox>
      </InputWidget>
    );
  }

  render() {
    const {
      isOpen, onCancel, onSubmit,
    } = this.props;

    return (
      <Modal
        isOpen={isOpen}
        onRequestClose={() => onCancel()}
        style={{ overlay: overlayStyle, content: contentStyle }}
        parentSelector={() => document.querySelector('#root')}
        shouldCloseOnOverlayClick={false}
      >
        <ModalContent>
          <ModalContent.Icon onClick={(e) => { onCancel(); e.stopPropagation(); }} />
          <InputContainer>
            {this.renderWidget('年', this.y, 'Year')}
            {this.renderWidget('月', this.m, 'Month')}
            {this.renderWidget('日', this.d, 'Day')}
          </InputContainer>
          <ModalContent.SubmitButton
            onClick={(e) => { onSubmit(); e.stopPropagation(); }}>
            确认
          </ModalContent.SubmitButton>
        </ModalContent>
      </Modal>
    );
  }
}

DateInputModal.defaultProps = {
};

DateInputModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onCancel: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
  onChange: PropTypes.func.isRequired,
  // used, but unrecognized by eslint
  // eslint-disable-next-line react/no-unused-prop-types
  value: PropTypes.string.isRequired,
};

export default DateInputModal;



// WEBPACK FOOTER //
// ./src/components/date-input-modal.jsx